"use client";

import Link from "next/link";
import type { ComponentProps } from "react";

import { clearScrollState } from "@/util/navigation";

/**
 * A hero call-to-action link. Clears the stored scroll state for its route
 * on click, which needs a handler and so a client component; the hero around
 * it renders on the server.
 */
export function HeroLink({
  href,
  ...props
}: Omit<ComponentProps<typeof Link>, "href" | "onClick"> & { href: string }) {
  return <Link href={href} onClick={() => clearScrollState(href)} {...props} />;
}
